import Marquee from "react-fast-marquee";
import { useLang } from "@/i18n";

export default function MarqueeSection() {
  const { t } = useLang();
  const items = t("marquee.items");
  return (
    <section
      data-testid="editorial-marquee"
      className="border-y border-[#E6E2DC] bg-surface py-8 md:py-10"
      aria-hidden="true"
    >
      <Marquee speed={38} gradient={false}>
        {items.map((item, i) => (
          <span key={i} className="mx-6 flex items-center gap-12">
            <span
              className={`font-display text-4xl font-semibold uppercase tracking-tight md:text-6xl ${
                i % 2 === 0 ? "text-outline" : "text-[#141210]"
              }`}
            >
              {item}
            </span>
            <span className="h-3 w-3 rotate-45 bg-neon-teal" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
